// Export

export default function (...args) {
    const valid_args = args.filter(arg => arg && arg.trim().length > 0)
    
    return valid_args.join(', ');
}
